// authService.js
import { auth } from '@/service/FirestoreService';

export const getCurrentUser = () => {
  return auth.currentUser;
};